export const text = {
  DELETE_VISIT_REMARK: 'Delete visit remark',
  ARE_YOU_SURE_YOU_WANT_DELETE: 'Are you sure you want to delete this visit remark?',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
}
